import action from 'app/lib/action';
import { LOGIN } from '../constants/actionTypes';

export default {
    request     : (username, password) => action(LOGIN.REQUEST)({username, password}),
    success     : (jwt, sessionData) => action(LOGIN.SUCCESS)({jwt, sessionData}),
    error       : (error) => action(LOGIN.ERROR)({error})
};
